<app-navbar-style-two></app-navbar-style-two>
<div class="inner-banner">
    <div class="container">
        <div class="inner-title text-center">
            <h3>Salesforce Developer Training </h3>
            <ul>
                <li><a href="index.html">Home</a></li>
                <li><i class='bx bx-chevron-right'></i></li>
                <li>Salesforce Developer</li>
            </ul>
        </div>
    </div>

    <div class="inner-banner-shape">
        <div class="shape-one"><img src="assets/img/inner-banner/banner-shape1.png" alt="Images"></div>
        <div class="shape-two"><img src="assets/img/inner-banner/banner-shape2.png" alt="Images"></div>
        <div class="shape-three"><img src="assets/img/inner-banner/banner-shape3.png" alt="Images"></div>
        <div class="inner-banner-dots"><img src="assets/img/shape/dots-shape.png" alt="Images"></div>
    </div>
</div>

<div class="services-details-area pt-50 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-left">
                    <div class="services-content">
                        <img src="assets/img/crm/SalesforceDeveloperTrainingBanner.jpg" alt="Images">
                        <h2>Empowering Developers with Salesforce Expertise</h2>
                        <p>Our Salesforce Developer Training equips you with essential skills to design, develop, and deploy applications on the Salesforce platform. Join us to enhance your expertise and boost your career opportunities.</p>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-sm-6">
                            <div class="services-content-card">
                                <div class="iconimg">
                                    <img src="assets/img/crm-icon/SalesforceDeveloperTraining/salesforceDelopmentskillstoday.png" alt="Images">
                                </div>
                                <h3>Master Salesforce Development Skills Today</h3>
                                <p>Master essential Salesforce development skills with our comprehensive training program and elevate your career prospects.</p>
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="services-content-card">
                                <div class="iconimg">
                                    <img src="assets/img/crm-icon/SalesforceDeveloperTraining/Unlockyourpotentialwithsalesforce.png" alt="Images">
                                </div>
                                <h3>Unlock Your Potential with Salesforce Training</h3>
                                <p>Unlock your potential with Salesforce Training, designed to equip you with essential skills for effective development and career advancement in tech.</p>
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="services-content-card">
                                <div class="iconimg">
                                    <img src="assets/img/crm-icon/SalesforceDeveloperTraining/Handsonlearning.png" alt="Images">
                                </div>
                                <h3>Hands-On Learning for Aspiring Developers</h3>
                                <p>Experience practical training in Salesforce development, enhancing your skills through real-world projects and mentorship.</p>
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="services-content-card">
                                <div class="iconimg">
                                    <img src="assets/img/crm-icon/SalesforceDeveloperTraining/Advanceyourcareerwithslalesforce.png" alt="Images">
                                </div>
                                <h3>Advance Your Career with Salesforce Expertise</h3>
                                <p>Elevate your career by mastering Salesforce development, gaining valuable skills that enhance job opportunities and industry relevance.</p>
                            </div>
                        </div>
                    </div>

                    <div class="content-widget-area">
                        <div class="row">
                            <div class="col-lg-6 col-md-12">
                                <div class="content-widget-img">
                                    <img src="assets/img/crm/SalesforceDeveloperImage.png" alt="Images">
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-12">
                                <div class="content-widget-text">
                                    <h2>Salesforce Developer Training Program</h2>
                                    <ul>
                                        <li><i class='bx bx-check'></i> Learn from Industry Experts</li>
                                        <li><i class='bx bx-check'></i> Hands-On Project Experience</li>
                                        <li><i class='bx bx-check'></i> Flexible Learning Options Available</li>
                                        <li><i class='bx bx-check'></i> Career Support and Guidance</li>
                                        <li><i class='bx bx-check'></i> Certification Preparation Included</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p>Avitron will provide you with a website that empowers you to showcase your products or services effectively. Take advantage of Salesforce Developer Training to boost your online presence and sales. Whether you need a new website or want to revamp your existing one, we have the expertise to deliver all your web development needs.</p>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-widget-right">
                    <app-sidebar></app-sidebar>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="brand-logo-area pt-100">
    <div class="container-fluid">
        <div class="container-max">
            <div class="brand-logo-slider owl-carousel owl-theme">
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo1.png" alt="Images">
                </div>
                
                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo2.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo3.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo4.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo5.png" alt="Images">
                </div>

                <div class="brand-logo-item">
                    <img src="assets/img/brand/brand-logo6.png" alt="Images">
                </div>
            </div>
        </div>
    </div>
</div> -->

<app-footer-style-two></app-footer-style-two>


